import React, { useState } from 'react'
import Content from 'blocks.app/content/content'
import Catalog from 'blocks.app/catalog/catalog'
import { checkAvailableModule } from '../../../core/helpers/routes/routes'
import { COURSES_CATALOG_CONFIG, COURSES_CATALOG_TYPE, CoursesSelectedItems } from './InstancesCatalogCourses-types'

const InstancesCatalogCoursesComponent = () => {
    const [selectedItems, setSelectedItems] = useState<CoursesSelectedItems>([])

    return (
        <Content title={COURSES_CATALOG_TYPE}>
            <Catalog
                type={COURSES_CATALOG_CONFIG.type}
                onSelect={setSelectedItems}
                selectedItems={selectedItems}
                fixedHeader={COURSES_CATALOG_CONFIG.fixedHeader}
                isExistRightToolbar={COURSES_CATALOG_CONFIG.isExistRightToolbar}
                treeView={COURSES_CATALOG_CONFIG.treeView}
            />
        </Content>
    )
}

export const InstancesCatalogCourses = checkAvailableModule('instancesCatalog/courses')
    ? InstancesCatalogCoursesComponent
    : null
